import React from 'react';

import { RightSidebar } from "src/pages/_partials/Layout";
import { BundleInterface } from "src/store/watcher/bundlesSlice";
import RowInfo from "src/componets/RowInfo";

const _SidebarShow = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  const renderDetails = () => {
    if(!bundle) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={bundle.id} />
          <RowInfo left='Bundle Name' right={bundle.name} />
          <RowInfo left='Platform' right={bundle.platform} />
          <RowInfo left='Version' right={bundle.version} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
